import { adjustmentSessionIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const cancelAdjustmentSession = {
  name: "cancelAdjustmentSession" as const,
  input: z.object({ sessionId: adjustmentSessionIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
